//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {apiUrl, apiParams} from '@/const/const'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
    name: "QuoteResult",
    components: {
        MyBtnReturn
    },
    data() {
        return {
            tableData: [],
            newData: [
                {
                    sPlace: '广州',
                    sPort: '黄埔港',
                    ePlace: '天津',
                    ePort: '天津港',
                    // ship_company: '',
                    truck_delivery: '远集拖车',
                    tf_loading1_t: 10,
                    // tf_loading2_t: 0,
                    // oceanfee: 0,
                    cont_fee: 10,
                    // order_fee: 0,
                    // baf: 0,
                    port_fee: 20,
                    // tf_delivery1: 0,
                    // tf_delivery2_t: 0,
                    // totalup1: 0,
                    // totalup2: 0,
                },
            ],// 假数据，后续要注释
            canFetch: true, // false为阻止继续获取数据
            isShowLoading: false,
            isShowTable: true,
            pageSize: 5, // 告知后台一次传回几条表格数据，默认5
            pageNo: 1, // 当前为第几页数据，要累加
            totalCount: 0, // 表格数据总条数，后台返回
            totalPages: 2, // 总页数，初始化必须比pageNo大；发现后台也有返回
            isNoData: false, // false代表还有数据
        }
    },
    created() {
        document.title = '报价查询';
        this.onScrollBottom() // 组件被创建时，就先获取一次数据
    },
    methods: {
        getData(url, data) {
            // 还要先判断到了最后一页了没
            if (this.pageNo > this.totalPages) {
                this.isShowLoading = false;
                this.canFetch = true;
                this.$vux.toast.show({
                    text: '暂无更多数据！',
                    time: 2000,
                    position: 'middle'
                });
                return
            }
            this.$vux.loading.show({
                text: 'Loading'
            });
            // 调用接口获取数据
            this.$http({
                method: 'post',
                url: url,
                data: data
            })
                .then((res) => {
                    let resultData = res.data; // 后台返回结果
                    let code = resultData.code;
                    let info = resultData.info; // 412或500的提示语
                    if (code === 412) {
                        this.$vux.toast.show({
                            // text: '状态出错，请重新操作！',
                            text: info,
                            time: 1000,
                            type: 'warn'
                        });
                        this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                        this.isShowLoading = false;
                        this.$vux.loading.hide();
                        return
                    }
                    if (code === 500) {
                        this.$vux.toast.show({
                            // text: '系统繁忙！',
                            text: info,
                            time: 1000,
                            type: 'warn'
                        });
                        this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                        this.isShowLoading = false;
                        this.$vux.loading.hide();
                        return
                    }
                    // 如果一切正常，那就渲染数据
                    this.$vux.loading.hide();
                    let dataObj = resultData.data.page;
                    if (dataObj.result.length === 0) {
                        // 如果没有数据了，要告知用户
                        this.isNoData = true;
                        this.isShowLoading = false;
                        // 如果第一页就没数据，那隐藏scroller
                        if (this.pageNo === 1) {
                            this.isShowTable = false
                        }
                        return
                    }
                    dataObj.result.forEach((item) => {
                        this.tableData.push(item)
                    }); // 表格数据是放在result中
                    this.totalCount = dataObj.totalCount;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                    this.pageNo++;
                    this.$nextTick(() => {
                        this.$refs.scrollerBottom.reset()
                    }); // 要重置scroller组件
                    this.isShowLoading = false;
                    this.canFetch = true
                })
                .catch((error) => {
                    this.canFetch = true;
                    this.$vux.loading.hide();
                    console.error(error.response);
                });
        },
        onScrollBottom() {
            this.isShowLoading = true;
            let query = this.$route.query;
            let data = {
                splace: query.splace,
                sport: query.sport,
                eport: query.eport,
                eplace: query.eplace,
                cont: query.cont,
                pageSize: this.pageSize, // 告知后台一次传回几条表格数据，默认5
                pageNo: this.pageNo, // 当前为第几页数据，要累加
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
            };
            if (!this.canFetch) {
            } else {
                this.canFetch = false;
                this.getData(apiUrl.quoteTemplate, data)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/yewu/quote/quoteResult/QuoteResult.vue